import { ICreateOrderDTO } from 'productTemplate/types/ICreateOrderDTO'
import { ParsedQs } from 'qs'

const convertQueryValueToNumber = (queryValue?: string) => {
  const num = Number(queryValue)
  if (!queryValue || Number.isNaN(num)) {
    return null
  }
  return num
}
interface IGetOrderInfoFromQueryParams {
  [key: string]: string[] | string | ParsedQs | ParsedQs[] | undefined
  expectedPriceCents?: string
  instantShip?: string
  productId?: string
  productTemplateId?: string
  size?: string
}

const getOrderInfoFromQueryParams = ({
  expectedPriceCents,
  instantShip,
  productId,
  productTemplateId,
  size,
}: IGetOrderInfoFromQueryParams): ICreateOrderDTO => {
  if ((!productId && !productTemplateId) || !expectedPriceCents) {
    throw new Error('Something went wrong creating your order. Please try again.')
  }
  const orderInfo: ICreateOrderDTO = {
    expectedPriceCents: convertQueryValueToNumber(expectedPriceCents)!,
    instantShip: instantShip === 'true',
    productId: convertQueryValueToNumber(productId),
    productTemplateId: convertQueryValueToNumber(productTemplateId),
    size: convertQueryValueToNumber(size),
  }
  Object.keys(orderInfo).forEach(key => {
    if (!orderInfo[key]) {
      delete orderInfo[key]
    }
  })
  return orderInfo
}

export default getOrderInfoFromQueryParams
